module.exports = __webpack_public_path__ + "img/posciutto-funghi.c8eb73e1.png";